import ReactGA from 'react-ga4';

class GoogleAnalyticsService {
  private initialized: boolean;

  constructor() {
    this.initialized = false;
  }

  initializeWithKey(key: string) {
    if (!this.initialized && key) {
      ReactGA.initialize(key);
      this.initialized = true;
    }
  }

  recordButtonClick = (buttonLabel: string) => {
    if (!this.initialized) return;

    ReactGA.event({
      category: 'Button',
      action: 'Click',
      label: buttonLabel
    });
  };

  recordPageView = () => {
    ReactGA.send({
      hitType: 'pageview',
      path: window.location.pathname + window.location.search
    });
  };
}

const googleAnalyticsService = new GoogleAnalyticsService();
export default googleAnalyticsService;
